// eslint-disable-next-line no-unused-vars
import { AxiosResponse } from 'axios';

import axiosInstance from './axiosInstance';

/**
 * @typedef {Object} ParamsAssignUserToCollectorAccount
 * @property {String | Number} id - Id de la cuenta recaudadora
 * @property {String} email - Email del usuario a asignar
 */

/**
 * Asigna un usuario a una cuenta recaudadora sin usuario asignado
 * @param {ParamsAssignUserToCollectorAccount} params
 * @returns {Promise<AxiosResponse>}
 */
const assignUserToCollectorAccount = (params) => {
  const { id, email } = params;

  return axiosInstance.patch(
    `/internal/admin/collector_accounts/${id}/assign_user`,
    { email },
  );
};

export default assignUserToCollectorAccount;
